import { VoxelData, MaterialType } from '../../voxelTypes';
import { PALETTE } from '../../voxelColor';

export interface CatalogColors {
  woodPrimary: number;
  woodHighlight: number;
  woodShadow: number;
  fabric: number;
  pot: number;
  bloom: number;
  metal: number;
  stone: number;
}

export type WoodFinish = 'oak' | 'walnut' | 'painted_pine';
export type FabricColor = 'red' | 'blue' | 'yellow' | 'cream' | 'green';
export type PotStyle = 'terracotta' | 'stone' | 'painted';
export type ExteriorFinish = 'new' | 'weathered';

export function getColors(options?: {
  woodFinish?: WoodFinish;
  fabricColor?: FabricColor;
  potStyle?: PotStyle;
  exteriorFinish?: ExteriorFinish;
  bloomColor?: number;
}): CatalogColors {
  const woodFinish = options?.woodFinish ?? 'oak';
  const fabricColor = options?.fabricColor ?? 'cream';
  const potStyle = options?.potStyle ?? 'terracotta';
  const exteriorFinish = options?.exteriorFinish ?? 'new';

  let woodPrimary = PALETTE.WOOD_OAK_MEDIUM;
  let woodHighlight = PALETTE.WOOD_OAK_LIGHT;
  let woodShadow = PALETTE.WOOD_OAK_DARK;

  if (woodFinish === 'walnut') {
    woodPrimary = 0x402b18;
    woodHighlight = 0x5a3f26;
    woodShadow = 0x27190e;
  } else if (woodFinish === 'painted_pine') {
    woodPrimary = 0x8a9e96; // Cozy sage green
    woodHighlight = 0xa3b5ad;
    woodShadow = 0x6e8078;
  }

  let fabric = 0xf5f5f0; // cream
  if (fabricColor === 'red') fabric = PALETTE.FLOWER_RED;
  else if (fabricColor === 'blue') fabric = PALETTE.FLOWER_BLUE;
  else if (fabricColor === 'yellow') fabric = PALETTE.FLOWER_YELLOW;
  else if (fabricColor === 'green') fabric = 0x467a31;

  let pot = 0x993922; // terracotta
  if (potStyle === 'stone') pot = PALETTE.STONE_MEDIUM;
  else if (potStyle === 'painted') pot = 0xdce3e1; // painted cream white

  let metal = 0x737d8c; // steel/iron
  let stone = PALETTE.STONE_MEDIUM;

  if (exteriorFinish === 'weathered') {
    metal = 0x4a756b; // oxidized copper/rust teal
    stone = 0x525c56; // mossy stone
    // weathered oak
    if (woodFinish === 'oak') {
      woodPrimary = 0x73787a;
      woodHighlight = 0x8c9294;
      woodShadow = 0x54595a;
    }
  }

  return {
    woodPrimary,
    woodHighlight,
    woodShadow,
    fabric,
    pot,
    bloom: options?.bloomColor ?? PALETTE.FLOWER_RED,
    metal,
    stone,
  };
}

export function addBox(
  voxels: VoxelData[],
  ox: number, oy: number, oz: number,
  w: number, h: number, d: number,
  color: number,
  materialType: MaterialType = 'opaque'
) {
  for (let x = 0; x < w; x++) {
    for (let y = 0; y < h; y++) {
      for (let z = 0; z < d; z++) {
        voxels.push({
          x: ox + x,
          y: oy + y,
          z: oz + z,
          color,
          scale: 1,
          materialType,
        });
      }
    }
  }
}

export function addMiniBox(
  voxels: VoxelData[],
  ox: number, oy: number, oz: number,
  w: number, h: number, d: number,
  color: number,
  materialType: MaterialType = 'opaque'
) {
  for (let x = 0; x < w; x++) {
    for (let y = 0; y < h; y++) {
      for (let z = 0; z < d; z++) {
        voxels.push({
          x: ox + x * 0.5,
          y: oy + y * 0.5,
          z: oz + z * 0.5,
          color,
          scale: 0.5,
          materialType,
        });
      }
    }
  }
}
